import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        card: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
            color: 'text.default',
        },
        infoPopBox: {
            marginLeft: '0',
        },
        textContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        strongText: {
            fontWeight: 'bold',
            color: 'text.success',
            textStyle: 'body-small',
            position: 'relative',
            top: remCalc(2),
        },
        normalText: {
            color: 'text.default',
            textStyle: 'body-small',
            position: 'relative',
            top: remCalc(2),
        },
        urlLink: {
            textDecoration: 'underline',
        },
        infoIcon: {
            boxSize: 'iconsSize.small',
            cursor: 'pointer',
            color: 'text.default',
            // fill="button.text.secondary-default"
        },
        icon: {
            boxSize: 'iconsSize.small',
            color: 'text.success',
        },
    },
    parts: ['card', 'infoPopBox', 'text', 'infoIcon'],
}
